import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c23cb07")

_pushScopeId("data-v-2c23cb07")
const _hoisted_1 = { class: "LTLInvoices" }
const _hoisted_2 = { class: "LTLInvoices__title" }
const _hoisted_3 = {
  key: 0,
  class: "LTLInvoices__header"
}
const _hoisted_4 = { class: "header__buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Добавить накладную ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Вернуться в заказ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" В мои накладные ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Создать новый заказ ")
const _hoisted_9 = {
  key: 0,
  class: "header__termsofuse"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "termsofuse__text" }, "Нажимая \"Создать новый заказ\" вы принимаете условия", -1)
const _hoisted_11 = { class: "LTLInvoices__invoices" }
const _hoisted_12 = {
  key: 1,
  class: "LTLInvoices__footer"
}
const _hoisted_13 = { class: "footer__buttons" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Добавить накладную ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Вернуться в заказ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" В мои накладные ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Создать новый заказ ")
const _hoisted_18 = {
  key: 0,
  class: "footer__termsofuse"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "termsofuse__text" }, "Нажимая \"Создать новый заказ\" вы принимаете условия", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!
  const _component_ltl_invoice = _resolveComponent("ltl-invoice")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.title) + " (" + _toDisplayString(_ctx.invoices.length) + ")", 1),
    (_ctx.invoices.length >= 2 && !_ctx.withoutHeaderAndFooter)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (!_ctx.blocked)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_s_button, {
                    loading: _ctx.loading,
                    class: "primary",
                    onClick: _ctx.emitCreate
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.isUpdate ? 'Завершить добавление накладных' : 'Создать заказ'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]),
                  (!_ctx.loading && !_ctx.isUpdate)
                    ? (_openBlock(), _createBlock(_component_s_button, {
                        key: 0,
                        class: "primary outline",
                        onClick: _ctx.emitStartAdd
                      }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.isUpdate)
                    ? (_openBlock(), _createBlock(_component_s_button, {
                        key: 0,
                        class: "primary",
                        onClick: _ctx.goInOrder
                      }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_s_button, {
                          class: "primary",
                          onClick: _ctx.goInInvoices
                        }, {
                          default: _withId(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_s_button, {
                          class: "primary outline",
                          onClick: _ctx.emitReset
                        }, {
                          default: _withId(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 64))
                ], 64))
          ]),
          (!_ctx.blocked && !_ctx.isUpdate)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("a", {
                  class: "termsofuse__link",
                  href: _ctx.OFFER_LINK,
                  target: "_blank"
                }, " Пользовательского соглашения ", 8, ["href"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_11, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, i) => {
        return (_openBlock(), _createBlock(_component_ltl_invoice, {
          key: `CompletedInvoice-${i}`,
          invoice: invoice,
          blocked: _ctx.blocked || _ctx.loading,
          isLTL: _ctx.isLTL,
          isFTL: _ctx.isFTL,
          "additional-services": _ctx.additionalServices,
          "is-bosch": _ctx.isBosch,
          onDeleteInvoice: ($event: any) => (_ctx.emitDelete(i)),
          onAddAdditionalServices: ($event) => _ctx.emitAddInvoiceAdditionalServices(i, $event),
          onResetAdditionalServices: ($event: any) => (_ctx.emitResetInvoiceAdditionalServices(i)),
          onStartUpdate: ($event: any) => (_ctx.emitUpdate(i))
        }, null, 8, ["invoice", "blocked", "isLTL", "isFTL", "additional-services", "is-bosch", "onDeleteInvoice", "onAddAdditionalServices", "onResetAdditionalServices", "onStartUpdate"]))
      }), 128))
    ]),
    (!_ctx.withoutHeaderAndFooter)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            (!_ctx.blocked)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_s_button, {
                    loading: _ctx.loading,
                    class: "primary",
                    onClick: _ctx.emitCreate
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.isUpdate ? 'Завершить добавление накладных' : 'Создать заказ'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]),
                  (!_ctx.loading && !_ctx.isUpdate)
                    ? (_openBlock(), _createBlock(_component_s_button, {
                        key: 0,
                        class: "primary outline",
                        onClick: _ctx.emitStartAdd
                      }, {
                        default: _withId(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.isUpdate)
                    ? (_openBlock(), _createBlock(_component_s_button, {
                        key: 0,
                        class: "primary",
                        onClick: _ctx.goInOrder
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_s_button, {
                          class: "primary",
                          onClick: _ctx.goInInvoices
                        }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_s_button, {
                          class: "primary outline",
                          onClick: _ctx.emitReset
                        }, {
                          default: _withId(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 64))
                ], 64))
          ]),
          (!_ctx.blocked && !_ctx.isUpdate)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("a", {
                  class: "termsofuse__link",
                  href: _ctx.OFFER_LINK,
                  target: "_blank"
                }, " Пользовательского соглашения ", 8, ["href"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})